import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth-store'

interface AdminRouteProps {
  children: React.ReactNode
}

/**
 * Admin-only route guard
 * Redirects non-admin users to the dashboard with a 403-style redirect
 */
export function AdminRoute({ children }: AdminRouteProps) {
  const user = useAuthStore((state) => state.user)

  if (!user) {
    return <Navigate to="/login" replace />
  }

  const isAdmin = user.roles.includes('ADMIN')

  if (!isAdmin) {
    return <Navigate to="/pac/dashboard" replace />
  }

  return <>{children}</>
}

export default AdminRoute
